import axios from '@axios'
export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getRooms(ctx, queryParams){
            const data = JSON.stringify(queryParams);

            return new Promise((resolve, reject) => {
                axios
                    .post(`/rooms/v1/getrooms`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        addRoom(ctx, queryParams){
            const data = JSON.stringify(queryParams);

            return new Promise((resolve, reject) => {
                axios
                    .post(`/rooms/v1/add`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updateRoom(ctx, queryParams){
            const data = JSON.stringify(queryParams);
            const id = queryParams.id
            return new Promise((resolve, reject) => {
                axios
                    .post(`/rooms/v1/update/${id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        deleteRoom(ctx, id){
            return new Promise((resolve, reject) => {
              axios
                .delete(`/rooms/v1/delete/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        getAmenities(ctx, queryParams){
            const data = JSON.stringify(queryParams);

            return new Promise((resolve, reject) => {
                axios
                    .post(`/rooms/v1/amenity/getall`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        addAmenity(ctx, queryParams){

            return new Promise((resolve, reject) => {
                axios
                    .post(`/rooms/v1/amenity/add`, queryParams.formData, {
                        headers:{
                            'Content-Type': 'multipart/form-data',
                            'dataType':'json'
                        }
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updateAmenity(ctx, queryParams){
            const id = queryParams.data.id

            return new Promise((resolve, reject) => {
                axios
                    .post(`/rooms/v1/amenity/update/${id}`, queryParams.formData, {
                        headers:{
                            'Content-Type': 'multipart/form-data',
                            'dataType':'json'
                        }
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        deleteAmenity(ctx, id){
            return new Promise((resolve, reject) => {
              axios
                .delete(`/rooms/v1/amenity/delete/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        updateOrdering(ctx, queryParams) {
            const data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
              axios
                .post('/rooms/v1/updateOrdering', data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        getFeatures(ctx, queryParams){
            const data = JSON.stringify(queryParams);

            return new Promise((resolve, reject) => {
                axios
                    .post(`/rooms/v1/feature/getAll`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        addFeature(ctx, queryParams){

            return new Promise((resolve, reject) => {
                axios
                    .post(`/rooms/v1/feature/add`, queryParams.formData, {
                        headers:{
                            'Content-Type': 'multipart/form-data',
                            'dataType':'json'
                        }
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updateFeature(ctx, queryParams){
            const id = queryParams.data.id

            return new Promise((resolve, reject) => {
                axios
                    .post(`/rooms/v1/feature/update/${id}`, queryParams.formData, {
                        headers:{
                            'Content-Type': 'multipart/form-data',
                            'dataType':'json'
                        }
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        deleteFeature(ctx, id){
            return new Promise((resolve, reject) => {
              axios
                .delete(`/rooms/v1/feature/delete/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        updateFeatureOrdering(ctx, queryParams) {
            const data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
              axios
                .post('/rooms/v1/feature/updateFeatureOrdering', data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
    }
}